<template>
  <div class="product-cnt">
    <div class="ty-banner-1"><img alt="河南万杰智能科技股份" src="@img/subpage-banner.jpg" title="河南万杰智能科技股份" /></div>
    <search-bar></search-bar>
    <div class="blk-main content clearafter">
      <div class="blk plc">
        <div class="p12-curmbs-1" navcrumbs="">
          <b>您的位置:</b>
          <router-link to="/">主页</router-link>
          &gt;
          <router-link to="/products/all">产品展示</router-link>
          &gt;
          <router-link v-if="curType" :to="curType">{{ curTypeName }}</router-link>
        </div>
      </div>
      <div class="clear"></div>
      <div class="blk-xs fl">
        <div class="fdh-01 blk">
          <div class="fdh-01-tit"><h3>产品展示</h3></div>
          <div class="fdh-01-nav">
            <div class="fdh-01-nav-one" v-for="(product, index) in productTypes" :key="index">
              <h3 :class="product.name | toPy | compare(curType, product.id)">
                <router-link :to="product.name | toPy('/products/')">{{ product.name }}</router-link>
              </h3>
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="blk-sm fr">
        <div class="lb-3n-ts-03 b">
          <h3 class="lb-3n-ts-03-tit">
            <span>{{ curTypeName || '产品展示' }}</span>
          </h3>
          <div class="cplb-3n-ts-03-list">
            <dl v-for="(product, index) in products" :key="index">
              <dt>
                <router-link target="_blank" :to="product.product_class_id | findpy(productTypes, product.id)">
                  <img :alt="product.product_name" :src="product.product_img_pc[0]" :title="product.product_name" />
                </router-link>
              </dt>
              <dd>
                <h4>
                  <router-link target="_blank" :to="product.product_class_id | findpy(productTypes, product.id)">
                    <b>{{ product.product_name }}</b>
                  </router-link>
                </h4>
              </dd>
            </dl>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="fenye">
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="total, prev, pager, next, jumper"
            :page-sizes="[12, 24, 36]"
            :hide-on-single-page="total < listQuery.limit"
            @pagination="product_info_list"
          />
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import searchBar from '@/components/common/searchBar.vue';
import Pagination from '@/components/common/pagination';
import utils from '@/api/to_py.js';
export default {
  data() {
    return {
      productTypes: [],
      curType: null,
      curTypeId: null,
      curTypeName: null,
      products: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 9
      },
      metaInfoAttr:{}
    };
  },
  components: {
    searchBar,
    Pagination
  },
  mounted() {
    this.getRroductType();
    this.curType = this.$route.params.name;
  },
  watch: {
    $route(to, from) {
      this.urlFindId();
    }
  },
  metaInfo() {
    return {
      title: this.metaInfoAttr.title,
      meta: [
        {
          name: 'keywords',
          content: this.metaInfoAttr.keywords
        },
        {
          name: 'description',
          content: this.metaInfoAttr.description
        }
      ]
    };
  },
  methods: {
    getseo() {
      this.$post('/api/getseo', {
        name: this.curTypeName
      }).then(res => {
        // console.log(res);
        if (res.data) {
          this.metaInfoAttr = res.data;
        } else {
          this.metaInfoAttr = {
            description:
              '万杰智能科技股份有限公司（www.wanjiejixie.com）创建于1996年3月，一直致力于和面系列、揉面系列、馒头系列、包馅系列、鲜食面条系列、蒸制系列、大型食品加工生产线系列等民族文化主食机械的研发、制造、营销和服务。 ',
            keywords: '馒头机,馒头生产线,包子机,和面机,揉面机',
            title: '馒头机|馒头生产线|包子机-万杰智能科技股份有限公司  '
          };
        }
      });
    },
    urlFindId() {
      // console.log(this.$route);
      this.curType = this.$route.params.name;
      if (this.curType != 'all') {
        this.productTypes.forEach(element => {
          if (this.curType == utils.ConvertPinyin(element.name)) {
            // console.log(element.id, element.name);
            this.curTypeId = element.id;
            this.curTypeName = element.name;
          }
        });
      } else {
        this.curTypeId = null;
        this.curTypeName = null;
      }
      this.getseo();
      this.product_info_list();
    },
    product_info_list: function() {
      this.$post('/Product/product_info_list', {
        product_class_id: this.curTypeId ? this.curTypeId : '',
        page: this.listQuery.page,
        limit: this.listQuery.limit
      }).then(response => {
        this.products = response.data || [];
        this.total = response.count;
      });
    },
    getRroductType: function() {
      this.$post('/Product/product_class_list', {}).then(response => {
        this.productTypes = response.data || [];
        this.urlFindId();
        this.product_info_list();
      });
    }
  },
  filters: {
    findpy(id, arrs, idd) {
      var baseurl = '/product/';
      arrs.forEach(element => {
        if (element.id == id) {
          baseurl += utils.ConvertPinyin(element.name) + '/' + idd + '.html';
          return;
        }
      });
      return baseurl;
    },
    toPy(parm, url) {
      var str = utils.ConvertPinyin(parm);
      if (url) str = url + str;
      return str;
    },
    compare(parm, type, id) {
      return parm == type ? 'nav-active' : '';
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@css/warp.less';
.product-cnt {
  background: rgba(247, 247, 247, 1);
  padding-bottom: 200px;

  .cplb-3n-ts-03-list {
    dl {
      width: 32.1%;
      border: 1px solid #dedede;
      margin-bottom: 20px;
      background: #fff;
      float: left;
      margin-right: 1.8%;
      &:nth-child(3n) {
        margin-right: 0;
      }
      &:hover {
        border-color: rgba(19, 181, 179, 1);
        a {
          color: rgba(19, 181, 179, 1);
        }
      }
      dd {
        padding: 0 20px;
        background: #ffffff;
        h4 {
          height: 45px;
          font-weight: normal;
          font-size: 16px;
          line-height: 45px;
          a {
            text-align: center;
            display: block;
            color: rgba(114, 114, 114, 1);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      dt {
        width: 100%;
        height: 296px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 100%;
          margin: 0 auto;
          display: block;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/products/index.vue